import React from 'react';

export const FeatureFlagContext = React.createContext({});

/**
 * @returns {Record<string, boolean>}
 */
export function useFeatureFlagContext() {
  return React.useContext(FeatureFlagContext);
}
